import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import QuickServices from '../components/QuickServices';
import CommonConcerns from '../components/CommonConcerns';
import Specializations from '../components/Specializations';
import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import AppDownload from '../components/AppDownload';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <QuickServices />
      <CommonConcerns />
      <Specializations />
      <Testimonials />
      <Blog />
      <AppDownload />
      <Footer />
    </>
  );
};

export default HomePage;